<template>
  <svg
      :class="{
        'panorama-slider-point': true,
        'panorama-slider-point--disabled': disabled
      }"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
  >
    <path v-if="left" d="M15 4.99951L9 11.9995L15 18.9995" stroke-linecap="round"/>
    <path v-if="right" d="M9 4.99951L15 11.9995L9 18.9995" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PanoramaSliderPoint',
  props: {
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.panorama-slider-point {
  width: 24px;
  height: 24px;
  @media screen and (min-width: 1920px) {
    width: 1.25vw;
    height: 1.25vw;
  }
  stroke: var(--panorama-text-color);
  &--disabled {
    filter: invert(1);
  }
}
</style>
